import { useState } from "react";

import { Button, ModalDelete } from "expano-components";

import { Main, PageLoader, Error } from "components";
import useGet from "hooks/useGet";
import useDelete from "hooks/useDelete";

import { ReactComponent as ProductIcon } from "icons/product.svg";

import BasicData from "./components/BasicData";

const VatRateEdit = ({
  match: {
    params: { id },
  },
  history,
}) => {
  const [show_delete_modal, setShowDeleteModal] = useState(false);

  const {
    is_loading,
    is_error,
    error,
    data: vat_rate,
    refetch,
  } = useGet({
    query: ["vat_rate", id],
    path: `/vat_rates/${id}`,
    context: "ui_show",
  });

  const { is_deleting, _delete } = useDelete({
    path: `/vat_rates/${id}`,
    onSuccess: () => history.push("/vat_rates"),
  });

  if (is_loading) {
    return <PageLoader />;
  }

  if (is_error) {
    return <Error message={error} />;
  }

  return (
    <Main
      page={{
        name: vat_rate?.name,
        icon: <ProductIcon />,
        breadcrumbs: [
          {
            name: "Stawki VAT",
            path: "/vat_rates",
          },
          { name: vat_rate?.name },
        ],
        buttons: (
          <Button
            type="delete"
            text="Usuń stawkę"
            disabled={is_deleting}
            onClick={() => setShowDeleteModal(true)}
          />
        ),
      }}
    >
      {show_delete_modal && (
        <ModalDelete
          handleDelete={_delete}
          handleClose={() => setShowDeleteModal(false)}
          name={`stawkę ${vat_rate?.name}?`}
        />
      )}
      <div className="dashboard-wrapper-flex">
        <div className="column-half">
          <BasicData
            vat_rate_id={id}
            refetch={refetch}
            initialValues={{
              name: vat_rate?.name,
              value: vat_rate?.value,
              country_code: vat_rate?.country_code,
            }}
          />
        </div>
      </div>
    </Main>
  );
};

export default VatRateEdit;
